import { ServiceBase } from 'travco-services';

class SearchService extends ServiceBase {
    
    constructor(token) {
        super();
        this._token = token;
    }

    getAllocationEnquiriesXmlRequest(search) {
        return super.fetch('api/search/allocations', 'post', JSON.stringify(search), this._token);
    }

    getHotelAvailabilityXmlRequest(search) {
        return super.fetch('api/search/hotels', 'post', JSON.stringify(search), this._token);
    }

    getHotelAvailability(search) {
        return super.fetch('api/search/HotelsAvailability', 'post', JSON.stringify(search), this._token);
    }

}

export default SearchService;